import { render, staticRenderFns } from "./createTarefe.vue?vue&type=template&id=5f6d62c9"
import script from "./createTarefe.vue?vue&type=script&lang=js"
export * from "./createTarefe.vue?vue&type=script&lang=js"
import style0 from "./createTarefe.vue?vue&type=style&index=0&id=5f6d62c9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports